// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Lawyers_contentWrapper__XEBq1","upperLine":"Lawyers_upperLine__2Smjj","items":"Lawyers_items__2Ovob"};